import { styled } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import AuthAnimateBackground from "./components/AuthAnimateBackground";
import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";

export const AuthSignUpPageContainer = styled("div")(({ theme }) => ({
  minHeight: "100%",
  height: "100%",
  width: "100%",
  justifyContent: "flex-start",
  flex: 1,
  alignItems: "center",
  position: "relative",
  display: "flex",
  flexDirection: "column",

  ".auth_container": {
    display: "flex",
    flexDirection: "column",
    maxWidth: 420,
    width: "100%",
    boxSizing: "border-box",
    padding: "50px 20px 50px 20px",
    minHeight: "100%",
    alignItems: "stretch",
    justifyContent: "flex-start",
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      maxWidth: "100%",
    },
    "> *": {
      marginLeft: "auto",
      marginRight: "auto",
    },
    ".page_title": {
      fontSize: 24,
      fontWeight: "bold",
      color: theme.vars.palette.text.primary,
      textAlign: "center",
      marginBottom: 9,
    },
    ".page_subtitle": {
      fontSize: 16,
      fontWeight: 500,
      color: theme.vars.palette.text.primary,
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    ".reward_summary": {
      marginTop: 30,
      fontSize: 14,
      textAlign: "center",
      fontWeight: 500,
      maxWidth: 255,
      color: theme.vars.palette.text.primary,
    },
    ".page_content": {
      marginTop: 30,
      marginBottom: 30,
      fontSize: 18,
      fontWeight: 500,
      color: theme.vars.palette.text.primary,
    },
    ".resend": {
      marginTop: 30,
      fontSize: 14,
      fontWeight: 500,
      color: theme.vars.palette.text.primary,
      ".click": {
        textDecoration: "underline",
        cursor: "pointer",
      },
    },
    ".cash_earned": {
      ".label": {},
      ".amount": {},
    },
    ".retailer_logo": {
      maxHeight: 93,
      width: 185,
      maxWidth: "100%",
      objectFit: "contain",
    },
    ".terms": {
      marginTop: 25,
      fontSize: 12,
      color: "#000",
      opacity: 0.3,
      textAlign: "center",
      a: {
        color: "#000",
        textDecoration: "underline",
      },
    },
  },
}));

const AuthSignUpPageOutlet = ({ animated }: { animated?: boolean }) => {
  const location = useLocation();
  const onSuccess = location.pathname?.toLowerCase().includes("success");
  const onSignin = location.pathname?.toLowerCase().includes("signin");
  const onSsoSign = location.pathname?.toLowerCase().includes("sso");
  const hideAnimation = onSuccess || onSignin || onSsoSign;

  return (
    <>
      {hideAnimation || !animated ? null : <AuthAnimateBackground />}
      <AuthSignUpPageContainer className="authSignUpPage">
        <Outlet />
      </AuthSignUpPageContainer>
    </>
  );
};

export default AuthSignUpPageOutlet;
